export const CAPITOLA_TINY_CLASS_PREFIX = 'cap-tiny';
const defaultEditorFontSize = 14;
export const defaultEditorFontSizeStringPx = `${defaultEditorFontSize}px`;
